import { render, staticRenderFns } from "./MailInvite.vue?vue&type=template&id=44c11476&scoped=true&"
import script from "./MailInvite.vue?vue&type=script&lang=ts&"
export * from "./MailInvite.vue?vue&type=script&lang=ts&"
import style0 from "./MailInvite.vue?vue&type=style&index=0&id=44c11476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c11476",
  null
  
)

export default component.exports